import { createAsyncAction } from 'typesafe-actions';
import { BuildItemResponse, BuildError, BuildListRequest } from './types';

export const buildList = createAsyncAction(
  'BUILD_LIST_REQUEST',
  'BUILD_LIST_SUCCESS',
  'BUILD_LIST_ERROR',
)<BuildListRequest, BuildItemResponse[], BuildError>();
